import { render, staticRenderFns } from "./entrace-info.vue?vue&type=template&id=67fc9fe6&scoped=true&"
import script from "./entrace-info.vue?vue&type=script&lang=js&"
export * from "./entrace-info.vue?vue&type=script&lang=js&"
import style0 from "./entrace-info.vue?vue&type=style&index=0&id=67fc9fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fc9fe6",
  null
  
)

export default component.exports